import * as Types from '../../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAiGeneratedWorkExperienceQueryVariables = Types.Exact<{
  input: Types.WorkExperienceSectionInput;
}>;


export type GetAiGeneratedWorkExperienceQuery = { __typename?: 'Query', generateWorkExperienceSection?: { __typename?: 'GenerateWorkExperienceSectionPayload', workExperienceDescription: string, explanation: string } | null };


export const GetAiGeneratedWorkExperienceDocument = gql`
    query GetAIGeneratedWorkExperience($input: WorkExperienceSectionInput!) {
  generateWorkExperienceSection(input: $input) {
    workExperienceDescription
    explanation
  }
}
    `;

/**
 * __useGetAiGeneratedWorkExperienceQuery__
 *
 * To run a query within a React component, call `useGetAiGeneratedWorkExperienceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiGeneratedWorkExperienceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiGeneratedWorkExperienceQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAiGeneratedWorkExperienceQuery(baseOptions: Apollo.QueryHookOptions<GetAiGeneratedWorkExperienceQuery, GetAiGeneratedWorkExperienceQueryVariables> & ({ variables: GetAiGeneratedWorkExperienceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiGeneratedWorkExperienceQuery, GetAiGeneratedWorkExperienceQueryVariables>(GetAiGeneratedWorkExperienceDocument, options);
      }
export function useGetAiGeneratedWorkExperienceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiGeneratedWorkExperienceQuery, GetAiGeneratedWorkExperienceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiGeneratedWorkExperienceQuery, GetAiGeneratedWorkExperienceQueryVariables>(GetAiGeneratedWorkExperienceDocument, options);
        }
export function useGetAiGeneratedWorkExperienceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAiGeneratedWorkExperienceQuery, GetAiGeneratedWorkExperienceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAiGeneratedWorkExperienceQuery, GetAiGeneratedWorkExperienceQueryVariables>(GetAiGeneratedWorkExperienceDocument, options);
        }
export type GetAiGeneratedWorkExperienceQueryHookResult = ReturnType<typeof useGetAiGeneratedWorkExperienceQuery>;
export type GetAiGeneratedWorkExperienceLazyQueryHookResult = ReturnType<typeof useGetAiGeneratedWorkExperienceLazyQuery>;
export type GetAiGeneratedWorkExperienceSuspenseQueryHookResult = ReturnType<typeof useGetAiGeneratedWorkExperienceSuspenseQuery>;
export type GetAiGeneratedWorkExperienceQueryResult = Apollo.QueryResult<GetAiGeneratedWorkExperienceQuery, GetAiGeneratedWorkExperienceQueryVariables>;